/// Sprite crop for a death-cause enemy, matching mobile/lib/game/enemy_data.dart.

export interface DeathCauseVisual {
  imagePath: string;
  sheetWidth: number;
  sheetHeight: number;
  srcWidth: number;
  srcHeight: number;
  srcX: number;
  srcY: number;
}

const pteroW = 46;
const pteroH = 40;
const smallW = 17;
const smallH = 35;
const smallSheetW = 102;
const largeW = 25;
const largeH = 50;
const largeSheetW = 75;
const mixedW = 75;
const mixedH = 50;

export function deathCauseVisual(cause: string, isDark: boolean): DeathCauseVisual | null {
  const mode = isDark ? 'dark' : 'light';

  switch (cause) {
    case 'pterodactyl':
      return {
        imagePath: `new/pterodactyl/${mode}.png`,
        sheetWidth: pteroW * 2,
        sheetHeight: pteroH,
        srcWidth: pteroW,
        srcHeight: pteroH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_small_single':
      return {
        imagePath: `new/cactus/small/${mode}.png`,
        sheetWidth: smallSheetW,
        sheetHeight: smallH,
        srcWidth: smallW,
        srcHeight: smallH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_small_double':
      return {
        imagePath: `new/cactus/small/${mode}.png`,
        sheetWidth: smallSheetW,
        sheetHeight: smallH,
        srcWidth: smallW * 2,
        srcHeight: smallH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_small_triple':
      return {
        imagePath: `new/cactus/small/${mode}.png`,
        sheetWidth: smallSheetW,
        sheetHeight: smallH,
        srcWidth: smallW * 3,
        srcHeight: smallH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_large_single':
      return {
        imagePath: `new/cactus/large/${mode}.png`,
        sheetWidth: largeSheetW,
        sheetHeight: largeH,
        srcWidth: largeW,
        srcHeight: largeH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_large_double':
      return {
        imagePath: `new/cactus/large/${mode}.png`,
        sheetWidth: largeSheetW,
        sheetHeight: largeH,
        srcWidth: largeW * 2,
        srcHeight: largeH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_large_triple':
      return {
        imagePath: `new/cactus/large/${mode}.png`,
        sheetWidth: largeSheetW,
        sheetHeight: largeH,
        srcWidth: largeSheetW,
        srcHeight: largeH,
        srcX: 0,
        srcY: 0,
      };
    case 'cactus_mixed':
      return {
        imagePath: `new/cactus/mixed/${mode}.png`,
        sheetWidth: mixedW,
        sheetHeight: mixedH,
        srcWidth: mixedW,
        srcHeight: mixedH,
        srcX: 0,
        srcY: 0,
      };
    default:
      return null;
  }
}
